<template>
    <v-container class="white mt-5">
        <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" sm="8" class="pb-6">
                <span class="header-title pt-5"> {{ $t('menu.system_setting') }} </span>
            </v-col>

            <v-col cols="12" sm="8">
                <v-textarea v-model="manufacture_email" v-bind:label="$t('setting.manufacture_mail')" outlined required></v-textarea>
            </v-col>

            <v-col cols="12" sm="8">
                <v-textarea v-model="gift_email" v-bind:label="$t('setting.gift_mail')" outlined required></v-textarea>
            </v-col>

            <v-col cols="12" sm="8">
                <v-numeric-field v-model="time_process" v-bind:label="$t('setting.time_process')" outlined required></v-numeric-field>
            </v-col>

            <v-col cols="12" sm="8">
                <v-numeric-field v-model="time_ship" v-bind:label="$t('setting.time_ship')" outlined required></v-numeric-field>
            </v-col>


            <v-col cols="12" sm="8">
                <v-autocomplete v-model="selectWeekend" :items="weekends" item-text="name" v-bind:label="$t('setting.weekend')" outlined return-object>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="8">
                <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" persistent width="290px">
                    <template v-slot:activator="{ on }">
                        <v-textarea v-model="computedDateFormatted" v-bind:label="$t('setting.holiday')" readonly v-on="on" outlined>
                        </v-textarea>
                    </template>
                    <v-date-picker v-model="dates" scrollable multiple locale="vi">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(dates)"> {{ $t('common.ok') }} </v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-col> 

             <v-col cols="12" sm="8">
                <v-btn large dark color="primary" @click="updateSettingInfor"> {{ $t('common.update') }} </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import VNumericField from "@/components/VNumericField";

export default {
    data: () => ({
        manufacture_email: '',
        gift_email: '',
        time_process: 24,
        time_ship: 24,
        weekends: [
            {name: 'Chủ nhật', value: 1},
            {name: 'Thứ 7 & Chủ nhật', value: 0}
        ],
        holiday: [],
        selectWeekend: {},

        dates: [],
        modal: false,

    }),

    watch: {
    },

    components: {
       VNumericField: VNumericField
    },

    computed: {
        computedDateFormatted () {
            let result = '';
            this.dates.forEach((item, index) => {
                result = result + this.formatDate(item)
                if (index < this.dates.length - 1) {
                   result = result + ", " 
                }
            });
            return result;
        },
    },

    created () {
        this.getSettingInfor();
        this.selectWeekend = this.weekends[0];
    },

    methods: {
        formatDate (date) {
            if (!date) {
                return null;
            }

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async getSettingInfor() {
            // moment(String(this.deadline)).format("DD/MM/YYYY"),
            try {
                const response =  await this.$http.get('/systemConfig/');
                if(response.data && response.data.success) {
                    // console.log(response.data);
                    const contextArr = response.data.data;
                    contextArr.forEach(item => {
                        if (item.key == 'ManufactureEmails') {
                            this.manufacture_email = item.value;
                        } else if (item.key == 'GiftTeamEmails') {
                            this.gift_email = item.value;
                        } else if (item.key == 'ManufactureRequest_RewardTimeout') {
                            this.time_process = item.value;
                        } else if (item.key == 'ManufactureRequest_ShipTimeout') {
                            this.time_ship = item.value;
                        } else if (item.key == 'ManufactureRequest_RewardWeekenTimeBonus') {
                            this.selectWeekend = this.weekends.find(date => date.value == item.value);
                        } else if (item.key == 'Hollidays') {
                            if (item.value && item.value.length > 0) {
                                this.dates = [];

                                const dateString = item.value.split(',');
                                dateString.forEach(date => {
                                    this.dates.push(moment(String(new Date(parseInt(date)))).format("YYYY-MM-DD"));
                                });
                            }
                            // this.date = this.weekends.find(date => date.value == item.value);
                        }
                    });
                } else if(response.data && !response.data.success) {
                    alert(i18n.t(response.data.message));
                } else {
                    alert(i18n.t('validate.request_error'));
                } 
            } catch(e) {
                alert(i18n.t('validate.request_error'));
            }
        },
        
        async updateSettingInfor() {
            let requestBody = [];
            requestBody.push({key: 'ManufactureEmails', value: this.manufacture_email, category: 'mail', description: 'Email team sản xuất'});
            requestBody.push({key: 'GiftTeamEmails', value: this.gift_email, category: 'mail', description: 'Email team quà tặng'});
            requestBody.push({key: 'ManufactureRequest_RewardTimeout', value: this.time_process, category: 'DesignRequest', description: 'Thời gian xử lý một YCTK của Designer'});
            requestBody.push({key: 'ManufactureRequest_ShipTimeout', value: this.time_ship, category: 'DesignRequest', description: 'Thời gian xử lý một YCTK của Designer'});
            requestBody.push({key: 'ManufactureRequest_RewardWeekenTimeBonus', value: this.selectWeekend.value, category: 'DesignRequest', description: 'Bỏ qua cuối tuần'});
            
            // console.log(requestBody);

            if (this.dates && this.dates.length > 0) {
                let holidays = '';
                this.dates.forEach((date, index) => {
                    holidays = holidays + new Date(date).getTime();
                    if (index < this.dates.length - 1) {
                        holidays = holidays + "," 
                    }
                });

                requestBody.push({key: 'Hollidays', value: holidays, category: 'DesignRequest', description: 'Danh sách ngày nghỉ'});
            }

            
            try {
                const response =  await this.$http.post('/systemConfig/', requestBody);
                if(response.data && response.data.success) {
                     this.$fire({
                        title: i18n.t('common.update_success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            
                    });
                }
            } catch(e) {
                console.log(e.stack);
            }
        }
    }
}
</script>